import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import LeaveProcessService from "../services/LeaveProcessService";
import "./AttendanceDashboard.css";
import { useLoading } from "../Utils/LoadingContext";
import { useNavigate } from "react-router-dom";

export default function AttendanceDashboard() {


  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const employeeCode = localStorage.getItem("empcode");
  const username = localStorage.getItem("username");
  const today = new Date();
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(employeeCode);
  const [selectedEmployeeName, setSelectedEmployeeName] = useState(username);
  const [month, setMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );
  const [calendarDate, setCalendarDate] = useState(today);
  const [monthSummary, setMonthSummary] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const [leaveBalance, setLeaveBalance] = useState([]);

  const [workingHours, setWorkingHours] = useState({
    expected: "0 hh",
    actual: "0 hh",
    deducted: "0 hh"
  });

  const [attendanceStats, setAttendanceStats] = useState({
    present: 0,
    paidLeave: 0,
    weeklyOff: 0,
    holidays: 0,
    absent: 0,
    unpaidLeave: 0,
    deductionLeave: 0,
    deductionPD: 0,
    arrears: 0,
    insentive: 0,
    totalPaidDays: 0,
    isSandwich: 0
  });

  useEffect(() => {
    loadEmployees();
    loadDashboard();
  }, []);


  useEffect(() => {

    if (!monthSummary.length) {
      setSelectedDay(null);
      setCalendarDate(today);
      return;
    }

    const todayKey = today.toDateString();

    const todayRecord = monthSummary.find((x) => {

      if (!x.punchDate) return false;

      const datePart = x.punchDate.split(" ")[0]; // MM/DD/YYYY
      const [mm, dd, yyyy] = datePart.split("/");

      const recordDate = new Date(yyyy, mm - 1, dd);

      return recordDate.toDateString() === todayKey;

    });

    if (todayRecord) {
      setSelectedDay(todayRecord);
    } else {
      setSelectedDay(null);
    }

    setCalendarDate(today);

  }, [monthSummary]);

  const getLeaveMMYY = () => {
    const [year, monthPart] = month.split("-");
    return `${monthPart}${year}`;
  };

  /* ================= EMPLOYEE LIST ================= */

  const loadEmployees = async () => {

    try {

      const formData = new FormData();
      formData.append("ManagerCode", employeeCode);
      formData.append("Type", "GetEmployeeList");
      debugger;
      const res = await LeaveProcessService.getEmployeeList(formData);

      // logged-in user
      const self = {
        employeeCode: employeeCode,
        employeeName: username
      };

      let employees = [];

      if (res?.data?.statusCode === 200) {
        employees = res.data.result || [];
      }

      // add self employee at top
      const list = [self, ...employees];

      setEmployeeList(list);

      // set default selected employee
      setSelectedEmployee(employeeCode);
      setSelectedEmployeeName(username);

    } catch (error) {

      console.log(error);

      // still show self employee even if API fails
      const self = {
        employeeCode: employeeCode,
        employeeName: username
      };

      setEmployeeList([self]);
      setSelectedEmployee(employeeCode);
      setSelectedEmployeeName(username);

    }

  };

  /* ================= ATTENDANCE DETAILS ================= */

  const loadAttendanceDetails = async () => {

    try {

      const formData = new FormData();
      formData.append("ManagerCode", employeeCode);
      formData.append("EmployeeCode", selectedEmployee);
      formData.append("LeaveMMYY", getLeaveMMYY());
      formData.append("Type", "GetEmployeeAttendanceDetails");
      const res = await LeaveProcessService.getEmployeeAttendanceDetails(formData);
      if (res.success) {

        const data = res.data[0];

       
        setAttendanceStats({
          present: data.present,
          paidLeave: data.paidLeave,
          weeklyOff: data.weeklyOff,
          holidays: data.holidays,
          absent: data.absent,
          unpaidLeave: data.unpaidLeave,
          deductionLeave: data.deductionLeave,
          deductionPD: data.deductionPD,
          arrears: data.arrears,
          insentive: data.insentive,
          totalPaidDays: data.totalPaidDays,
          isSandwich: data.isSandwich
        });

        setWorkingHours({
          expected: data.expected + " HH",
          actual: data.actual + "HH",
          deducted: data.deducted + " MM"
        });

      }

      else {
        const message = res.errorMessage || 'Submission failed. Please try again.';
        //toast.error(message);
        console.error("Else error:", message);
        setLoading(false);
      }
    } catch (error) {
      const message = error?.message || 'Unexpected error occurred.';
      // toast.error(message);
      console.error("Unhandled error:", message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  /* ================= CALENDAR DATA ================= */

  const loadDashboard = async () => {

    try {

      if (!isValidMonthSelection()) {
        alert("You can select only previous, current or future month.");
        return;
      }

      await loadAttendanceDetails();

      const formData = new FormData();
      formData.append("EmployeeCode", selectedEmployee);
      formData.append("Type", "GetMonthSummary");
      formData.append("LeaveMMYY", getLeaveMMYY());

      const res = await LeaveProcessService.getEmployeeCalender(formData);

      if (res.data.statusCode === 200) {
        const data = res.data.result || [];
        setMonthSummary(data);
      }

    } catch (error) {
      console.error(error);
    } finally {
      loadLeaveBalance();
    }

  };

  /* ================= LEAVE BALANCE ================= */

  const loadLeaveBalance = async () => {
    try {
      const formData = new FormData();

      formData.append("EmployeeCode", selectedEmployee);
      formData.append("Type", "GetLeave");
      formData.append("LeaveMMYY", getLeaveMMYY());

      const res = await LeaveProcessService.getEmployeeDashBoard(formData);

      if (res.data.statusCode === 200) {

        setLeaveBalance(
          res.data.result.map(x => ({
            leaveCode: x.leaveCode,
            totalBalance: x.availableBalance
          }))
        );

      }
    }
    catch (error) {
      const message = error?.message || 'Unexpected error occurred.';
      // toast.error(message);
      console.error("Unhandled error:", message);
      setLoading(false);
    } finally {
      setLoading(false);
    }

  };

  /* ================= CALENDAR STATUS ================= */

  const statusMap = {};

  monthSummary.forEach(x => {

    if (x.punchDate) {

      const parts = x.punchDate.split(" ")[0].split("/");

      const d = new Date(parts[2], parts[0] - 1, parts[1]);

      statusMap[d.toDateString()] = x;

    }

  });

  // const handleDateClick = (date) => {

  //   const data = statusMap[date.toDateString()];
  //   setSelectedDay(data || null);
  //   setCalendarDate(date);

  // };

  const handleDateClick = (date) => {
    const data = statusMap[date.toDateString()];

    console.log("Clicked Date Data:", data);

    setSelectedDay(data || null);
    setCalendarDate(date);

    if (data) {
      setShowAttendanceModal(true);
    }
  };
  const isValidMonthSelection = () => {

    const [year, monthPart] = month.split("-");

    const selectedDate = new Date(year, monthPart - 1, 1);

    const currentDate = new Date();

    const currentMonthStart = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1
    );

    const prevMonthStart = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      1
    );

    // ❌ Block only older than previous month
    if (selectedDate < prevMonthStart) {
      return false;
    }

    // ✅ Allow previous, current, future
    return true;
  };
  const clearDashboardData = () => {

    setMonthSummary([]);
    setSelectedDay(null);
    setLeaveBalance([]);

    setWorkingHours({
      expected: "0 HH",
      actual: "0 HH",
      deducted: "0 MM"
    });

    setAttendanceStats({
      present: 0,
      paidLeave: 0,
      weeklyOff: 0,
      holidays: 0,
      absent: 0,
      unpaidLeave: 0,
      deductionLeave: 0,
      deductionPD: 0,
      arrears: 0,
      insentive: 0,
      totalPaidDays: 0,
      isSandwich: 0
    });

  };


  return (

    <div className="container py-3">

      {/* ================= FILTER ================= */}

      <div className="dashboard-filter-card">

        <div className="filter-left">

          <div className="filter-item">
            <label>Self / Team Member</label>
            <select
              value={selectedEmployee}
              onChange={(e) => {
                const code = e.target.value;
                const emp = employeeList.find(x => x.employeeCode === code);

                setSelectedEmployee(code);
                setSelectedEmployeeName(emp?.employeeName || "");
              }}
            >
              {employeeList.map((emp, index) => (
                <option key={index} value={emp.employeeCode}>
                  {emp.employeeName} ({emp.employeeCode})
                </option>
              ))}
            </select>
          </div>

          <div className="filter-item">
            <label>Month</label>
            <input
              type="month"
              value={month}
              onChange={(e) => setMonth(e.target.value)}
            />
          </div>

          <button
            className="show-btn"
            onClick={() => {
              clearDashboardData();
              loadDashboard();
            }}
          >
            Show
          </button>

        </div>

        <div className="filter-right">
          <button
            className="attendance-btn"
            onClick={() => navigate("/EmployeeAttendance")}
          >
            <i className="fa fa-fingerprint"></i>
            Attendance
          </button>
        </div>

      </div>


      {/* ================= WORKING HOURS ================= */}

      <div className="working-hours-card">
        <div className="emp-box">
          <span>Employee Code</span>
          <b>{selectedEmployee}</b>
        </div>

        <div className="emp-box">
          <span>Employee Name</span>
          <b>{selectedEmployeeName}</b>
        </div>
        <div className="hours-box">
          <span>Expected</span>
          <b>{workingHours.expected}</b>
        </div>

        <div className="hours-box">
          <span>Actual</span>
          <b>{workingHours.actual}</b>
        </div>

        <div className="hours-box">
          <span>Deducted</span>
          <b>{workingHours.deducted}</b>
        </div>

      </div>

      {/* ================= ATTENDANCE SUMMARY ================= */}

      <div className="summary-card">

        <div className="summary-item present">
          <b>{attendanceStats.present}</b>
          <span>Present</span>
        </div>

        <div className="summary-item leave">
          <b>{attendanceStats.paidLeave}</b>
          <span>Paid Leave</span>
        </div>

        <div className="summary-item holiday">
          <b>{attendanceStats.weeklyOff}</b>
          <span>Weekly Off</span>
        </div>

        <div className="summary-item holiday-day">
          <b>{attendanceStats.holidays}</b>
          <span>Holiday</span>
        </div>

        <div className="summary-item absent">
          <b>{attendanceStats.absent}</b>
          <span>Absent</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.unpaidLeave}</b>
          <span>Unpaid Leave</span>
        </div>
        <div className="summary-item deduction">
          <b>{attendanceStats.isSandwich}</b>
          <span>Sandwich </span>
        </div>
        <div className="summary-item deduction">
          <b>{attendanceStats.deductionLeave}</b>
          <span>Deduction (Leave)</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.deductionPD}</b>
          <span>Deduction (Paid days)</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.arrears}</b>
          <span>Arrears</span>
        </div>

        <div className="summary-item deduction">
          <b>{attendanceStats.insentive}</b>
          <span>Incentive</span>
        </div>

        <div className="summary-item holiday">
          <b>{attendanceStats.totalPaidDays}</b>
          <span>Total Paid Days</span>
        </div>

      </div>

      {/* ================= CALENDAR ================= */}

      <div className="row">

        <div className="dashboard-grid">

          <Calendar
            className="dashboard-card"
            value={calendarDate}
            onClickDay={handleDateClick}
            maxDate={today}
            activeStartDate={new Date(month + "-01")}
            prevLabel={null}
            nextLabel={null}
            prev2Label={null}
            next2Label={null}
            navigationLabel={null}
            tileClassName={({ date }) => {

              const s = statusMap[date.toDateString()];

              if (!s) return "";

              if (s.status === "PP" || s.status === "OD" || s.status === "AR") return "present-day";
              if (s.status === "AA") return "absent-day";
              if (s.status === "WO") return "holiday";
              if (s.status === "HO") return "holiday-day";
              if (s.status === "PA") return "halfday";
              if (s.status === "AP") return "halfday";
              if (["CL", "PL", "ACL", "CLA", "CLP", "PCL"].includes(s.status)) return "leave-day";

            }}

          />



          {/* Quick Actions */}
          <div className="dashboard-card">
            <h5>Quick Actions</h5>

            <div className="action-grid">

              <div
                className="action-card blue"
                onClick={() => navigate("/EmployeeAttendance")}
              >
                <i className="fa fa-fingerprint"></i>
                <span>My Attendance</span>
              </div>

              <div
                className="action-card green"
                onClick={() => navigate("/LeaveApply")}
              >
                <i className="fa fa-calendar"></i>
                <span>Apply Leave</span>
              </div>

              <div
                className="action-card orange"
                onClick={() => navigate("/AttendanceRegularization")}
              >
                <i className="fa fa-refresh"></i>
                <span>AR</span>
              </div>

              <div
                className="action-card purple"
                onClick={() => navigate("/OnDutyApply")}
              >
                <i className="fa fa-briefcase"></i>
                <span>OD</span>
              </div>

            </div>
          </div>
          {/* Leave Balance */}
          <div className="dashboard-card">
            <div className="card-header">
              <h5>My Leave Balance</h5>
              <button className="link-btn" onClick={() => navigate("/LeaveApply")}>Apply</button>
            </div>

            {leaveBalance.map((item, index) => (
              <div className="leave-item" key={index}>
                <div className="leave-row">
                  <span>{item.leaveCode}</span>
                  <span>{item.totalBalance} left</span>
                </div>

                <div className="progress">
                  <div
                    className="progress-fill"
                    style={{
                      width: `${Math.min(item.totalBalance * 10, 100)}%`
                    }}
                  />
                </div>
              </div>
            ))}
          </div>

        </div>

        {/* </div> */}

      </div>

      {/* <div className="row">
        <div className="dashboard-grid">
        
          <div className="dashboard-card">
            <div className="card-header">
              <h5>My Recent Requests</h5>
              <button className="link-btn">View All</button>
            </div>

            <div className="request-item">
              <div>
                <strong>Earned Leave</strong>
                <div>08 Mar · 2d</div>
              </div>

              <span className="approved-badge">
                Approved
              </span>
            </div>
          </div>

        </div>

      </div> */}

      {showAttendanceModal && selectedDay && (
        <div className="attendance-modal-overlay"
          onClick={() => setShowAttendanceModal(false)}
        >
          <div
            className="attendance-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h5>{calendarDate.toDateString()}</h5>

              <button
                className="close-btn"
                onClick={() => setShowAttendanceModal(false)}
              >
                ✕
              </button>
            </div>

            <div className="modal-body">

              <p><strong>Status:</strong> {selectedDay.status}</p>

              <p>
                <strong>Working Hours:</strong>
                {" "}
                {selectedDay.totalMinutes || "00:00"}
              </p>

              <p>
                <strong>Shift:</strong>
                {" "}
                {selectedDay.shiftName}
              </p>

              <p>
                <strong>In Time:</strong>
                {" "}
                {selectedDay.firstPunchIn || "-"}
              </p>

              <p>
                <strong>Out Time:</strong>
                {" "}
                {selectedDay.lastPunchOut || "-"}
              </p>

              <p>
                <strong>Deduction:</strong>
                {" "}
                {selectedDay.deductionMinutes || "00:00"}
              </p>

              <p>
                <strong>Incentive:</strong>
                {" "}
                {selectedDay.overtimeminutes
                  ? selectedDay.overtimeminutes + " MM"
                  : "00 MM"}
              </p>

            </div>
          </div>
        </div>
      )}

    </div>
  );
}